/** Impl dos use cases admin de Protocolo. @since G.5.6 */
import type { Page } from '@/domain/model/Page';
import type { Protocolo } from '@/domain/model/Protocolo';
import type {
  ProtocoloAdminGateway, FilaProtocolosParams,
} from '@/application/port/out/ProtocoloAdminGateway';
import type {
  ListFilaPorSetorUseCase, ClaimProtocoloUseCase,
} from '@/application/port/in/ProtocoloAdminUseCase';

export class ListFilaPorSetor implements ListFilaPorSetorUseCase {
  constructor(private readonly g: ProtocoloAdminGateway) {}
  execute(setorId: string, params: FilaProtocolosParams): Promise<Page<Protocolo>> {
    return this.g.filaPorSetor(setorId, params);
  }
}
export class ClaimProtocolo implements ClaimProtocoloUseCase {
  constructor(private readonly g: ProtocoloAdminGateway) {}
  execute(id: string): Promise<Protocolo> { return this.g.claim(id); }
}
